import UnitBeneficialOwnerStatus from "../../enums/unit-bank-account/UnitBeneficialOwnerStatus.enum";
import { UnitOccupation } from "../../enums/unit-bank-account/UnitOccupation.enum";
import { UnitRevenue } from "../../enums/unit-bank-account/UnitRevenue.enum";
import { UnitSourceOfIncome } from "../../enums/unit-bank-account/UnitSourceOfIncome.enum";
import { UnitAddress } from "./UnitAddress.model";
import { UnitFullName } from "./UnitFullName.model";
import { UnitPhone } from "./UnitPhone.model";

export class UnitBeneficialOwnerReqRes {
  /** ID in our database (not related to Unit) */
  public id: number;

  /** One of Approved, Denied or PendingReview. */
  public status: UnitBeneficialOwnerStatus;

  /** Full name of the beneficial owner. */
  public fullName: UnitFullName;

  /** SSN of the beneficial owner (numbers only). One of ssn or passport is required. */
  public ssn: string;

  /** Passport of the beneficial owner. One of ssn or passport is required. */
  public passport: string;

  /** Only when Passport is populated. Two letters representing the beneficial owner's nationality. */
  public nationality: string;

  public dateOfBirth: Date;

  /** The beneficial owner's address. */
  public address: UnitAddress;

  /** The beneficial owner's phone number. */
  public phone: UnitPhone;

  /** The beneficial owner's email address. */
  public email: string;

  /** The beneficial owner percentage of ownership at the business. */
  public percentage: string;

  public occupation: UnitOccupation;
  public annualIncome: UnitRevenue;
  public sourceOfIncome: UnitSourceOfIncome;
}
